import { cx } from '../../../utils/cx';
import { cva, type VariantProps } from 'class-variance-authority';

const spinnerVariants = cva(
  'animate-spin rounded-full border-2 border-current border-t-transparent text-brand-600',
  {
    variants: {
      size: {
        small: 'h-4 w-4 border-2',
        medium: 'h-6 w-6 border-2',
        large: 'h-8 w-8 border-3'
      }
    },
    defaultVariants: {
      size: 'medium'
    }
  }
);

export interface LoadingSpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {
  stretch?: boolean;
}

export function LoadingSpinner({
  className,
  size,
  stretch,
  ...props
}: LoadingSpinnerProps) {
  const spinner = (
    <div className={cx(spinnerVariants({ size }), className)} {...props} />
  );

  if (stretch) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
}
